import { render, staticRenderFns } from "./ElectrodePasteParaEdit.vue?vue&type=template&id=60f7e9a0&"
import script from "./ElectrodePasteParaEdit.vue?vue&type=script&lang=js&"
export * from "./ElectrodePasteParaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports